import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/JobAuditReport/Filter'

export default createListViewComponent({
  entityName: entityNames.jobAuditReport,
  filterTemplateType: 'JobAuditReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
